(function ($, Drupal, once, duo) {
  Drupal.behaviors.datepicker = {
    attach: function (context, settings) {
      $(".js-datepicker-years-filter").each(function () {
        $(this).datepicker({
          onSelect: function (d, i) {
            if (d !== i.lastVal) {
              $(this).change();
            }
          },
        });
        $(this).change(function () {
          $(this).datepicker("destroy");
        });
      });
    },
  };
})(jQuery, Drupal, once, (window.duo = window.duo || {}));
